import React from 'react';

import { CheckmarkAnimation } from '@eika/checkmark-animation';

import ActionResultInfo from '../../../../components/shared/ActionResultInfo/ActionResultInfo';
import useTranslation from '../../../../hooks/useTranslation';

const UnapproveSuccess: React.FC = () => {
    const translated = useTranslation();

    return (
        <div className="component-group outbox-item__container outbox-item-success">
            <ActionResultInfo
                title={translated.outbox.unapproveItemSuccess}
                defaultError={translated.outbox.unapproveItemSuccess}
                icon={<CheckmarkAnimation mini className="edit-salary-info--result__icon" />}
            />
        </div>
    );
};

export default UnapproveSuccess;
